import { render, staticRenderFns } from "./StatutCourse.vue?vue&type=template&id=6624db91&scoped=true&"
import script from "./StatutCourse.vue?vue&type=script&lang=js&"
export * from "./StatutCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624db91",
  null
  
)

export default component.exports